import { read, utils, WorkBook } from "xlsx";

export type ExcelReadObject = { [name: string]: any };

export const readXlsxFile = async (data: File): Promise<ExcelReadObject> => {
  const arrayBuffer = await data.arrayBuffer();
  const workbook: WorkBook = read(arrayBuffer);
  const results: ExcelReadObject = {};
  workbook.SheetNames.forEach((sheetName: string) => {
    results[sheetName] = utils.sheet_to_json(workbook.Sheets[sheetName]);
  });
  return results;
};
